import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const CultureValues = () => {
  return (
    <>
      <SEO 
        title="Culture & Values - Abacies Logiciels"
        description="Discover the culture and values that drive Abacies Logiciels - continuous learning, innovation with purpose, accountability, and a commitment to long-term client success."
        keywords="company culture, values, workplace culture, Abacies values, technology company culture, innovation culture"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Culture & Values
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Culture & Values page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Culture & Values. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default CultureValues;
